// covered-by: frontends/carrie/src/utils/__tests__/buildMentionComposerMembers.test.ts

export type MentionComposerMember = {
  _id: string;
  name?: string;
  email?: string;
  avatar?: string | null;
};

/** Deduped roster + allow-list members for @mention autocomplete. */
export function buildMentionComposerMembers(
  rosterMembers: readonly MentionComposerMember[],
  allowListMembers: readonly MentionComposerMember[],
): MentionComposerMember[] {
  const seen = new Set<string>();
  const out: MentionComposerMember[] = [];
  const push = (member: MentionComposerMember) => {
    if (seen.has(member._id)) return;
    seen.add(member._id);
    out.push(member);
  };
  for (const member of rosterMembers) push(member);
  for (const member of allowListMembers) push(member);
  return out;
}
